module.exports = __webpack_public_path__ + "static/logo-sprites-vertical-8b702e59bd803c2b0c71bb141b544578.png";